import { useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ControlButton } from 'ui/components/ControlButton/ControlButton';
import { ReactComponent as IconShareScreen } from 'static/ic-share-screen.svg';
import { ReactComponent as IconShareStop } from 'static/ic-share-stop.svg';
import { selectLocalParticipant } from 'state/selectors';
import { CURRENT_SCREEEN_SHARING_PRESET } from './consts';

interface ScreenShareButtonProps {
    disabled?: boolean;
    tooltipTitle?: string;
}

export const ScreenShareButton = observer(({ disabled: externalDisabled, tooltipTitle }: ScreenShareButtonProps) => {
    const { t } = useTranslation();
    const [screenButtonDisabled, setScreenButtonDisabled] = useState(false);
    const localParticipant = selectLocalParticipant();

    if (!localParticipant) return null;

    const isLocalParticipantSharingScreen = localParticipant.isScreenShareEnabled;
    const title =
        tooltipTitle ?? t(isLocalParticipantSharingScreen ? 'web_call_tooltip_screen_off' : 'web_call_share_screen');

    const handleClick = useCallback(() => {
        if (externalDisabled) return;
        setScreenButtonDisabled(true);
        localParticipant
            .setScreenShareEnabled(!isLocalParticipantSharingScreen, undefined, CURRENT_SCREEEN_SHARING_PRESET)
            .catch((e) => console.error("Can't start screen share,", e))
            .finally(() => setScreenButtonDisabled(false));
    }, [localParticipant, isLocalParticipantSharingScreen, externalDisabled]);

    return (
        <ControlButton
            title={title}
            IconImage={isLocalParticipantSharingScreen ? IconShareStop : IconShareScreen}
            disabled={screenButtonDisabled || externalDisabled}
            active={!isLocalParticipantSharingScreen}
            onClick={handleClick}
        />
    );
});

ScreenShareButton.displayName = 'ScreenShareButton';
